import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./SettingsItem.module.css";
import { useTranslation } from "react-i18next";

export const SettingsItem = ({ header, max, onChange, value }) => {
  const {t} = useTranslation();
  const [selected, setSelected] = useState(value);

  const handleChange = (direction) => {
    onChange(direction);
    if (direction == 0) {
      setSelected(selected - 1);
    } else if (direction == 1) {
      setSelected(selected + 1);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>{t(header)}</div>
      <div>
        {selected !== 1 ? (
          <div className={styles.option} onClick={() => handleChange(0)}>
            {selected - 1}
          </div>
        ) : (
          <div className={styles.option}></div>
        )}
        <div className={styles.selected}>{selected}</div>
        {selected < max ? (
          <div className={styles.option} onClick={() => handleChange(1)}>
            {selected + 1}
          </div>
        ) : (
          <div className={styles.option}></div>
        )}
      </div>
    </div>
  );
};

SettingsItem.propTypes = {};
